import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  Nav,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap"
import { getEmailSetup, getVisitorList } from "store/actions"
import EmailMessagesTab from "./emailMessagesTab"
import VisitorListTab from "./visitorListTab"

const VisitorRegistration = ({
  loading,
  visitors,
  getVisitorList,
  getEmailSetup,
}) => {
  const TABS = {
    VISITOR_LIST: 1,
    EMAIL_MESSAGES: 2,
  }

  useEffect(() => {
    getVisitorList({
      o: "created_at",
      od: "desc",
      page: 1,
    })
    getEmailSetup({})
  }, [])

  const [activeTab, setActiveTab] = useState(TABS.VISITOR_LIST)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Visitors" />
        <Container fluid>
          <BreadcrumbTitle
            title="Visitors"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Visitors",
                type: "tab",
                clickHandler: () => {
                  setActiveTab(TABS.VISITOR_LIST)
                },
              },
              { title: activeTab === 1 ? "Visitor List" : "Email Messages" },
            ]}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.VISITOR_LIST)}
                      onClick={() => setActiveTab(TABS.VISITOR_LIST)}
                    >
                      <span style={{ fontSize: "16px" }}>Visitor List</span>
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.EMAIL_MESSAGES)}
                      onClick={() => setActiveTab(TABS.EMAIL_MESSAGES)}
                    >
                      <span style={{ fontSize: "16px" }}>Email Messages</span>
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.VISITOR_LIST}>
                      <VisitorListTab />
                    </TabPane>
                    <TabPane tabId={TABS.EMAIL_MESSAGES}>
                      <EmailMessagesTab />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={loading} centered={true} size="sm">
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  visitors: state.Visitors.visitors,
  loading: state.Visitors.loading,
})

const mapDispatchToProps = dispatch => ({
  getVisitorList: values => dispatch(getVisitorList(values)),
  getEmailSetup: values => dispatch(getEmailSetup(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(VisitorRegistration)
